export default __webpack_public_path__ + "static/media/icon-envelope.8fd0cb1a.svg";